import {
  REPORT_TYPE_ACTIVITY_CAPITAL_RAISE_DEBT, REPORT_TYPE_ACTIVITY_CAPITAL_RAISE_FUND,
  REPORT_TYPE_ASSET_LOAN_TAPE, REPORT_TYPE_ASSET_PORTFOLIO, REPORT_TYPE_DEAL_PIPELINE_SUMMARY,
  REPORT_TYPE_DEAL_BUILD_TO_SUIT_PIPELINE_SUMMARY, REPORT_TYPE_DEAL_POWER_BI_DATASET,
  REPORT_TYPE_DEAL_TASK_DUE_DILIGENCE_STATUS,
} from './report-types';

export const REPORT_TYPE_LIST_PORTFOLIOS_FILTER: string[] = [
  REPORT_TYPE_DEAL_PIPELINE_SUMMARY,
  REPORT_TYPE_DEAL_BUILD_TO_SUIT_PIPELINE_SUMMARY,
  REPORT_TYPE_DEAL_POWER_BI_DATASET,
  REPORT_TYPE_ACTIVITY_CAPITAL_RAISE_DEBT,
  REPORT_TYPE_ACTIVITY_CAPITAL_RAISE_FUND,
  REPORT_TYPE_ASSET_PORTFOLIO,
  REPORT_TYPE_ASSET_LOAN_TAPE,
];

export const REPORT_TYPE_LIST_HIDDEN_PORTFOLIOS: string[] = [
  REPORT_TYPE_ASSET_PORTFOLIO,
  REPORT_TYPE_ASSET_LOAN_TAPE,
];

export const REPORT_TYPE_LIST_DEALS_FILTER: string[] = [
  REPORT_TYPE_ACTIVITY_CAPITAL_RAISE_DEBT,
  REPORT_TYPE_ACTIVITY_CAPITAL_RAISE_FUND,
  REPORT_TYPE_DEAL_TASK_DUE_DILIGENCE_STATUS,
];

export const REPORT_TYPE_LIST_DEAL_FIELDS_FILTER: string[] = [
  REPORT_TYPE_DEAL_PIPELINE_SUMMARY,
  REPORT_TYPE_DEAL_BUILD_TO_SUIT_PIPELINE_SUMMARY,
];

export const REPORT_TYPE_LIST_ACTIVITY_FIELDS_FILTER: string[] = [
  REPORT_TYPE_ACTIVITY_CAPITAL_RAISE_DEBT,
  REPORT_TYPE_ACTIVITY_CAPITAL_RAISE_FUND,
];

export const REPORT_DEAL_CUSTOM_SECTION_FIELD_MAP: Record<string, [string, string][]> = {
  [REPORT_TYPE_DEAL_BUILD_TO_SUIT_PIPELINE_SUMMARY]: [
    ['Rental Property Overview', 'Use'],
    ['Rental Property Overview', 'Lease Term (Years)'],
    ['Rental Property Overview', 'Escalations'],
    ['Rental Property Overview', 'RSF'],
    ['Rental Property Overview', 'Year 1 Rent / SF'],
    ['Rental Property Overview', 'Developer'],
    ['Tenant Credit Overview', 'Tenant Name'],
    ['Tenant Credit Overview', 'Credit (Y/N)'],
    ['Tenant Credit Overview', 'Parent Ticker Symbol'],
    ['Tenant Credit Overview', 'Parent Credit Rating'],
    ['Tenant Credit Overview', 'Most Recent Year EBITA'],
    ['Tenant Credit Overview', 'Most Recent Year Assets'],
    ['Transaction Overview', 'Type'],
    ['Transaction Overview', 'Deal Size'],
    ['Transaction Overview', 'Esti. YoC'],
    ['Transaction Overview', 'MSA (Rank)'],
    ['Transaction Overview', 'Source'],
    ['Transaction Overview', 'Estimated Closing Date'],
  ],
};
